


import { useTranslation } from "react-i18next";

import TabelBodypPayrolls from "../tabelbodypayrolls";


const PayrollsDetalis = ({payllors}) => {

const {t} = useTranslation()

  return (
    <div className="container-fluid"> 
      <div className="card">
        <div class="table-responsive-sm">
        <table className="table-responsive-sm table table-striped table-hover">
            <thead >    
              <th>{t("#")}</th>
              <th>{t("Employe")}</th>
            <th>{t("deserved_amount")}</th> 
            <th>{t("undeserved_amount")}</th> 
            <th>{t("extra_amount")}</th> 
            <th>{t("discount_amount")}</th> 
            <th>{t("loan_amount")}</th> 
            <th>{t("status")}</th> 
            <th>{t("date")}</th> 
            <th>{t("Active")}</th>
            </thead>
          <tbody>
       {payllors.map((payllor)=>(
        <TabelBodypPayrolls key={payllor.id} payllor={payllor}/>
       ))  }
          </tbody>
        </table> 
        </div>
        
      </div>
   
    </div>
  );
};

export default PayrollsDetalis;